import { isDataGridScope, isPluginScope } from '../helpers';
import { AppStructureBuilderError } from './error';
export function addColumn({ columnName, columnType, viewName, scopeName }) {
    this.updateAppStructure(draftBuilder => {
        const { scope } = draftBuilder.getScopeByView({ scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}.`);
        }
        if (isPluginScope(scope)) {
            throw new AppStructureBuilderError(`Scope ${scopeName} is a plugin scope and cannot have columns.`);
        }
        if (!isDataGridScope(scope)) {
            throw new AppStructureBuilderError(`Scope ${scopeName} is not a data grid scope. Columns can only be added to data grid scopes.`);
        }
        if (!scope.columns) {
            scope.columns = {};
        }
        const numberOfColumns = Object.keys(scope.columns).length;
        const modelField = draftBuilder.getEntityField(scope.entityName, columnName);
        const type = draftBuilder.getColumnType({ columnType, modelField });
        scope.columns[columnName] = draftBuilder.newElementColumn({
            columnName,
            columnType: type,
            numberOfColumns,
            modelField,
        });
    });
    return this;
}
export function removeColumn({ viewName, scopeName, columnName }) {
    this.updateAppStructure(draftBuilder => {
        const { scope } = draftBuilder.getScopeByView({ scopeName, viewName });
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (!isDataGridScope(scope)) {
            throw new AppStructureBuilderError(`Scope ${scopeName} is not a data grid scope. Column can only be removed from data grid scopes.`);
        }
        if (!scope.columns) {
            throw new AppStructureBuilderError(`Scope ${scopeName} has no columns`);
        }
        delete scope.columns[columnName];
    });
    return this;
}
//# sourceMappingURL=columnManagement.js.map